// 期間の正規表現フォーマット
const REGEX = /(20\d\d)\/([0-1]\d)\/([0-3]\d) ([0-2]\d):([0-5]\d)/;

/**
 * セレクトボックスでの期間編集コンポーネント
 */
export default {
    template: '#selectbox_editor_component_template',
    data() {
        const m = moment();
        const years = [
            m.add(1, 'years').format('YYYY'),
            m.subtract(1, 'years').format('YYYY'),
            m.subtract(1, 'years').format('YYYY')
        ];
        return {
            // 去年、今年、来年
            years: years,
            focus: false,
            selected: {}
        };
    },
    props: {
        // YYYY/MM/DD HH/II
        modelValue: {
            type: String
        },
        // 選択不可日
        props_disabled_dates: {
            type: Object,
            default: () => ({to: null, from: null}),
            require: false,
        },
    },
    watch: {
        // 親コンポーネントの変更時、セレクトボックスに適用
        modelValue: {
            immediate: true,
            handler(value) {
                this.selected = this.convertObject(value);
            }
        },
        // セレクトボックスの変更時、親へ通知
        selected: {
            handler: function () {
                this.emitUpdateValue();
            },
            deep: true
        }
    },
    computed: {
        // 年、月から日付を割り出す
        days: function () {
            if (this.selected.year && this.selected.month) {
                return moment(this.selected.year + '-' + this.selected.month, 'YYYY-MM').daysInMonth();
            }
            return 0;
        },
    },
    emits: ['update:modelValue'],
    methods: {
        // 選択不可の年か否か
        isDisabledYear: function (year) {
            if (this.props_disabled_dates.to) {
                const selected = year + '-01-01';
                if (!moment(selected).isBetween(this.props_disabled_dates.to, this.props_disabled_dates.from, 'year', '[]')) {
                    return true;
                }
            }
            return false;
        },
        // 選択不可の月か否か
        isDisabledMonth: function (month) {
            if (this.props_disabled_dates.to) {
                // 年が未選択だったら選択不可
                if (!this.selected.year) {
                    return true;
                }
                const selected = this.selected.year + '-' + this.zeroPadding(month) + '-01';
                if (!moment(selected).isBetween(this.props_disabled_dates.to, this.props_disabled_dates.from, 'month', '[]')) {
                    return true;
                }
            }
            return false;
        },
        // 選択不可の日か否か
        isDisabledDay: function (day) {
            if (this.props_disabled_dates.to) {
                // 年、月が未選択だったら選択不可
                if (!this.selected.year || !this.selected.month) {
                    return true;
                }
                const selected = this.selected.year + '-' + this.zeroPadding(this.selected.month) + '-' + this.zeroPadding(day);
                if (!moment(selected).isBetween(this.props_disabled_dates.to, this.props_disabled_dates.from, 'day', '[]')) {
                    return true;
                }
            }
            return false;
        },
        // 選択不可の時間か否か
        isDisabledHour: function (hour) {
            if (this.props_disabled_dates.to) {
                // 年、月、日が未選択だったら選択不可
                if (!this.selected.year || !this.selected.month || !this.selected.day) {
                    return true;
                }
                const selected = this.selected.year + '-' + this.zeroPadding(this.selected.month) + '-' + this.zeroPadding(this.selected.day) + ' ' + this.zeroPadding(hour) + ':00';
                if (!moment(selected).isBetween(this.props_disabled_dates.to, this.props_disabled_dates.from, 'hour', '[]')) {
                    return true;
                }
            }
            return false;
        },
        // 選択不可の分か否か
        isDisabledMinute: function (minute) {
            if (this.props_disabled_dates.to) {
                // 年、月、日、時が未選択だったら選択不可
                if (!this.selected.year || !this.selected.month || !this.selected.day || !this.selected.hour) {
                    return true;
                }
                const selected = this.selected.year + '-' + this.selected.month + '-' + this.selected.day + ' ' + this.selected.hour + ':' + this.zeroPadding(minute);
                if (!moment(selected).isBetween(this.props_disabled_dates.to, this.props_disabled_dates.from, 'minute', '[]')) {
                    return true;
                }
            }
            return false;
        },
        // 先頭に0を付けて桁をそろえる
        zeroPadding: function (num) {
            return ('00' + num).slice(-2);
        },
        // 日付文字列からobjectに変換
        convertObject: function (value) {
            if (value) {
                const matches = value.match(REGEX);
                if (matches) {
                    return {
                        year: matches[1],
                        month: matches[2],
                        day: matches[3],
                        hour: matches[4],
                        min: matches[5]
                    };
                }
            }
            return {
                year: null,
                month: null,
                day: null,
                hour: null,
                min: null
            };
        },
        // objectから日付文字列に変換
        convertText: function () {
            return this.selected.year + '/' + this.selected.month + '/' + this.selected.day + ' ' + this.selected.hour + ':' + this.selected.min;
        },
        // 変更を親へ通知
        emitUpdateValue: function () {
            // nullが1つでもあったらemitしない
            for (let i in this.selected) {
                if (this.selected[i] === null) {
                    return;
                }
            }
            this.$emit('update:modelValue', this.convertText());
        }
    }
};
